"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6523],{

/***/ 73759:
/***/ (function(module) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var validateFormat =  false ? 0 : function (format) {};
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments to provide
 * information about what broke and what you were expecting.
 *
 * The invariant message will be stripped in production, but the invariant will
 * remain to ensure logic does not differ in production.
 */

function invariant(condition, format) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  validateFormat(format);

  if (!condition) {
    var error;

    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return String(args[argIndex++]);
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // Skip invariant's own stack frame.

    throw error;
  }
}

module.exports = invariant;

/***/ }),

/***/ 46523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ Box; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86872);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _helpers_analytics__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60368);
/* harmony import */ var _helpers_tokens__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61274);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);







var BaseBox = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_2__.styled)(_tamagui_core__WEBPACK_IMPORTED_MODULE_2__.View, {
    name: "Box",
    tag: "div",
    variants: {
        shadow: function(shadowToken) {
            return (0,_helpers_tokens__WEBPACK_IMPORTED_MODULE_3__/* .getShadowProps */ .dh)(shadowToken);
        }
    }
}), Box = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(_param, ref) {
    var analyticsName = _param.analyticsName, _trackImpression = _param.trackImpression, trackImpression = _trackImpression === void 0 ? !1 : _trackImpression, inViewThreshold = _param.inViewThreshold, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "analyticsName",
        "trackImpression",
        "inViewThreshold"
    ]);
    var BaseBoxWithProps = /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BaseBox, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        ref: ref
    }, props));
    return analyticsName && trackImpression ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_helpers_analytics__WEBPACK_IMPORTED_MODULE_6__/* .ComponentWithViewTracking */ .o, {
        Component: BaseBoxWithProps,
        analyticsName: analyticsName,
        eventName: "boxViewEvent",
        inViewThreshold: inViewThreshold,
        ref: ref
    }) : BaseBoxWithProps;
});



/***/ }),

/***/ 60368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* binding */ ComponentWithViewTracking; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/node_modules/react-intersection-observer/index.mjs
"use client";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/InView.tsx


// src/observe.ts
var observerMap = /* @__PURE__ */ new Map();
var RootIds = /* @__PURE__ */ new WeakMap();
var rootId = 0;
var unsupportedValue = void 0;
function defaultFallbackInView(inView) {
  unsupportedValue = inView;
}
function getRootId(root) {
  if (!root)
    return "0";
  if (RootIds.has(root))
    return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
function optionsToId(options) {
  return Object.keys(options).sort().filter(
    (key) => options[key] !== void 0
  ).map((key) => {
    return `${key}_${key === "root" ? getRootId(options.root) : options[key]}`;
  }).toString();
}
function createObserver(options) {
  let id = optionsToId(options);
  let instance = observerMap.get(id);
  if (!instance) {
    const elements = /* @__PURE__ */ new Map();
    let thresholds;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        var _a;
        const inView = entry.isIntersecting && thresholds.some((threshold) => entry.intersectionRatio >= threshold);
        if (options.trackVisibility && typeof entry.isVisible === "undefined") {
          entry.isVisible = inView;
        }
        (_a = elements.get(entry.target)) == null ? void 0 : _a.forEach((callback) => {
          callback(inView, entry);
        });
      });
    }, options);
    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id,
      observer,
      elements
    };
    observerMap.set(id, instance);
  }
  return instance;
}
function observe(element, callback, options = {}, fallbackInView = unsupportedValue) {
  if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
    const bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return () => {
    };
  }
  const { id, observer, elements } = createObserver(options);
  let callbacks = elements.get(element) || [];
  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }
  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    callbacks.splice(callbacks.indexOf(callback), 1);
    if (callbacks.length === 0) {
      elements.delete(element);
      observer.unobserve(element);
    }
    if (elements.size === 0) {
      observer.disconnect();
      observerMap.delete(id);
    }
  };
}

// src/InView.tsx
function isPlainChildren(props) {
  return typeof props.children !== "function";
}
var InView = class extends react.Component {
  constructor(props) {
    super(props);
    __publicField(this, "node", null);
    __publicField(this, "_unobserveCb", null);
    __publicField(this, "handleNode", (node) => {
      if (this.node) {
        this.unobserve();
        if (!node && !this.props.triggerOnce && !this.props.skip) {
          this.setState({ inView: !!this.props.initialInView, entry: void 0 });
        }
      }
      this.node = node ? node : null;
      this.observeNode();
    });
    __publicField(this, "handleChange", (inView, entry) => {
      if (inView && this.props.triggerOnce) {
        this.unobserve();
      }
      if (!isPlainChildren(this.props)) {
        this.setState({ inView, entry });
      }
      if (this.props.onChange) {
        this.props.onChange(inView, entry);
      }
    });
    this.state = {
      inView: !!props.initialInView,
      entry: void 0
    };
  }
  componentDidMount() {
    this.unobserve();
    this.observeNode();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  }
  componentWillUnmount() {
    this.unobserve();
  }
  observeNode() {
    if (!this.node || this.props.skip)
      return;
    const {
      threshold,
      root,
      rootMargin,
      trackVisibility,
      delay,
      fallbackInView
    } = this.props;
    this._unobserveCb = observe(
      this.node,
      this.handleChange,
      {
        threshold,
        root,
        rootMargin,
        // @ts-ignore
        trackVisibility,
        // @ts-ignore
        delay
      },
      fallbackInView
    );
  }
  unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();
      this._unobserveCb = null;
    }
  }
  render() {
    const { children } = this.props;
    if (typeof children === "function") {
      const { inView, entry } = this.state;
      return children({ inView, entry, ref: this.handleNode });
    }
    const {
      as,
      triggerOnce,
      threshold,
      root,
      rootMargin,
      onChange,
      skip,
      trackVisibility,
      delay,
      initialInView,
      fallbackInView,
      ...props
    } = this.props;
    return React.createElement(
      as || "div",
      { ref: this.handleNode, ...props },
      children
    );
  }
};

// src/useInView.tsx

function useInView({
  threshold,
  delay,
  trackVisibility,
  rootMargin,
  root,
  triggerOnce,
  skip,
  initialInView,
  fallbackInView,
  onChange
} = {}) {
  var _a;
  const [ref, setRef] = react.useState(null);
  const callback = react.useRef();
  const [state, setState] = react.useState({
    inView: !!initialInView,
    entry: void 0
  });
  callback.current = onChange;
  react.useEffect(
    () => {
      if (skip || !ref)
        return;
      let unobserve;
      unobserve = observe(
        ref,
        (inView, entry) => {
          setState({
            inView,
            entry
          });
          if (callback.current)
            callback.current(inView, entry);
          if (entry.isIntersecting && triggerOnce && unobserve) {
            unobserve();
            unobserve = void 0;
          }
        },
        {
          root,
          rootMargin,
          threshold,
          // @ts-ignore
          trackVisibility,
          // @ts-ignore
          delay
        },
        fallbackInView
      );
      return () => {
        if (unobserve) {
          unobserve();
        }
      };
    },
    // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // If the threshold is an array, convert it to a string, so it won't change between renders.
      // eslint-disable-next-line react-hooks/exhaustive-deps
      Array.isArray(threshold) ? threshold.toString() : threshold,
      ref,
      root,
      rootMargin,
      triggerOnce,
      skip,
      trackVisibility,
      fallbackInView,
      delay
    ]
  );
  const entryTarget = (_a = state.entry) == null ? void 0 : _a.target;
  const previousEntryTarget = react.useRef();
  if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
    previousEntryTarget.current = entryTarget;
    setState({
      inView: !!initialInView,
      entry: void 0
    });
  }
  const result = [setRef, state.inView, state.entry];
  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}

//# sourceMappingURL=index.mjs.map
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/Dimensions/index.js
var Dimensions = __webpack_require__(95998);
// EXTERNAL MODULE: ./node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(86872);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/helpers/useObservabilitySafe.js
var useObservabilitySafe = __webpack_require__(1252);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/helpers/analytics.js










var useTrackComponentInViewForWeb = function(eventName, analyticsName, options) {
    var trackJourneyEvent = (0,useObservabilitySafe/* useObservabilitySafe */.r)().trackJourneyEvent, ref = (0,_sliced_to_array/* default */.Z)(useInView((0,_object_spread/* default */.Z)({
        // https://react-intersection-observer.vercel.app/?path=/docs/useinview-hook--basic
        // threshold: Number between 0 and 1 indicates the percentage that should be visible
        // before triggering. (defaults to 100% unless an override is provided)
        threshold: 1,
        skip: !analyticsName,
        triggerOnce: !0
    }, options)), 2), inViewRef = ref[0], inView = ref[1];
    return (0,react.useEffect)(function() {
        inView && trackJourneyEvent("platform", eventName, {
            targetName: analyticsName
        });
    }, [
        inView,
        analyticsName
    ]), (0,react.useMemo)(function() {
        return inViewRef;
    }, [
        inViewRef
    ]);
}, WebComponentWithViewTracking = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var Component = props.Component, analyticsName = props.analyticsName, eventName = props.eventName, inViewThreshold = props.inViewThreshold, inViewRef = useTrackComponentInViewForWeb(eventName, analyticsName, {
        threshold: inViewThreshold
    });
    return /*#__PURE__*/ (0,react.cloneElement)(Component, {
        ref: (0,cjs.useComposedRefs)(inViewRef, ref)
    });
}), MobileComponentWithViewTracking = /*#__PURE__*/ (0,react.forwardRef)(function(props, _ref) {
    var Component = props.Component, analyticsName = props.analyticsName, eventName = props.eventName;
    var inViewThreshold = props.inViewThreshold || 1;
    var trackJourneyEvent = (0,useObservabilitySafe/* useObservabilitySafe */.r)().trackJourneyEvent, inViewRef = (0,react.useRef)(null), ref = (0,react.useState)(!1), trackedInView = ref[0], setTrackedInView = ref[1], interval = (0,react.useRef)(null), startWatching = (0,react.useCallback)(function() {
        interval.current || trackedInView || (interval.current = setInterval(function() {
            var ref;
            !inViewRef || !inViewRef.current || ((ref = inViewRef.current) === null || ref === void 0 ? void 0 : ref.measure(function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function(_x, _y, width, height, pageX, pageY) {
                    var window, componentHeight, componentWidth, rectBottom, rectTop, rectRight, isVisible;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        window = Dimensions/* default.get */.Z.get("window");
                        (height > window.height || width > window.width) && (inViewThreshold = (height > window.height ? window.height / height : window.width / width) - 0.01);
                        componentHeight = height * inViewThreshold, componentWidth = width * inViewThreshold, rectBottom = pageY + componentHeight, rectTop = pageY, rectRight = pageX + componentWidth, isVisible = rectBottom !== 0 && // Check if the bottom edge is not at the top (initialized value)
                        rectTop >= 0 && // Check if the top edge is greater than or equal to the top of the viewport
                        rectBottom <= window.height && // Check if the bottom edge is within the inViewThreshold percentage of the viewport height
                        rectRight >= 0 && // Check if the width is greater than 0 (initialized value)
                        rectRight <= window.width;
                        trackedInView !== isVisible && (setTrackedInView(isVisible), trackJourneyEvent("platform", eventName, {
                            targetName: analyticsName
                        }));
                        return [
                            2
                        ];
                    });
                });
                return function(_x, _y, width, height, pageX, pageY) {
                    return _ref.apply(this, arguments);
                };
            }()));
        }, 300));
    }, [
        trackedInView,
        inViewThreshold,
        trackJourneyEvent,
        eventName,
        analyticsName
    ]), stopWatching = (0,react.useCallback)(function() {
        interval.current && (clearInterval(interval.current), interval.current = null);
    }, []);
    return (0,react.useEffect)(function() {
        return trackedInView || startWatching(), stopWatching;
    }, [
        startWatching,
        stopWatching,
        trackedInView
    ]), /* @__PURE__ */ (0,jsx_runtime.jsx)(cjs.View, {
        ref: inViewRef,
        collapsable: !1,
        children: Component
    });
}), ComponentWithViewTracking = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var Component = props.Component, analyticsName = props.analyticsName, eventName = props.eventName, inViewThreshold = props.inViewThreshold;
    return cjs.isWeb ? /* @__PURE__ */ (0,jsx_runtime.jsx)(WebComponentWithViewTracking, {
        Component: Component,
        analyticsName: analyticsName,
        eventName: eventName,
        inViewThreshold: inViewThreshold,
        ref: ref
    }) : /* @__PURE__ */ (0,jsx_runtime.jsx)(MobileComponentWithViewTracking, {
        Component: Component,
        analyticsName: analyticsName,
        eventName: eventName,
        inViewThreshold: inViewThreshold,
        ref: ref
    });
});



/***/ }),

/***/ 12554:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ls": function() { return /* binding */ getRGBA; }
/* harmony export */ });
/* unused harmony exports getB, getG, getR, getRGB, hex, shortToLongHex */
var hex = function(x) {
    return x.toString(16).length === 1 ? "0" + x.toString(16) : x.toString(16);
}, shortToLongHex = function(hex2) {
    var r = hex2.substring(1, 2), g = hex2.substring(2, 3), b = hex2.substring(3);
    return "#".concat(r).concat(r).concat(g).concat(g).concat(b).concat(b);
}, getR = function(c) {
    return parseInt(c.substring(1, 3), 16);
}, getG = function(c) {
    return parseInt(c.substring(3, 5), 16);
}, getB = function(c) {
    return parseInt(c.substring(5), 16);
}, getRGB = function(hex2) {
    return hex2.length === 4 && (hex2 = shortToLongHex(hex2)), "rgb(".concat(getR(hex2), ", ").concat(getG(hex2), ", ").concat(getB(hex2), ")");
}, getRGBA = function(hex2, opacity) {
    return hex2.length === 4 && (hex2 = shortToLongHex(hex2)), "rgba(".concat(getR(hex2), ", ").concat(getG(hex2), ", ").concat(getB(hex2), ", ").concat(opacity, ")");
};



/***/ }),

/***/ 61274:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GJ": function() { return /* binding */ getStateTokenValue; },
/* harmony export */   "Re": function() { return /* binding */ getPercentageTokenValue; },
/* harmony export */   "dh": function() { return /* binding */ getShadowProps; },
/* harmony export */   "vs": function() { return /* binding */ getOpacityTokenValue; }
/* harmony export */ });
/* unused harmony exports getRadiusTokenValue, getSizeTokenValue, getSpaceTokenValue */
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86872);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _convertColor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12554);


var getRadiusTokenValue = function(radiusToken) {
    return getTokens().radius[radiusToken].val;
}, getSizeTokenValue = function(sizeToken) {
    return getTokens().size[sizeToken].val;
}, getSpaceTokenValue = function(spaceToken) {
    return getTokens().space[spaceToken].val;
}, getOpacityTokenValue = function(opacityToken) {
    return (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_0__.getTokens)().opacity[opacityToken].val;
}, getStateTokenValue = function(stateToken) {
    return (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_0__.getTokens)().state[stateToken].val;
}, getShadowProps = function(shadowToken) {
    var tokens = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_0__.getTokens)(), shadowOpacity = tokens.shadowOpacity[shadowToken].val;
    return {
        shadowColor: _tamagui_core__WEBPACK_IMPORTED_MODULE_0__.isWeb ? (0,_convertColor__WEBPACK_IMPORTED_MODULE_1__/* .getRGBA */ .ls)((0,_tamagui_core__WEBPACK_IMPORTED_MODULE_0__.getTokenValue)(shadowToken, "color"), shadowOpacity) : shadowToken,
        shadowOpacity: shadowOpacity,
        shadowOffset: {
            width: tokens.shadowOffsetWidth[shadowToken].val,
            height: tokens.shadowOffsetHeight[shadowToken].val
        },
        shadowRadius: tokens.shadowRadius[shadowToken].val,
        elevationAndroid: tokens.elevation[shadowToken].val
    };
}, getPercentageTokenValue = function(percentageToken) {
    return (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_0__.getTokens)().percentages[percentageToken].val;
};



/***/ }),

/***/ 1252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ useObservabilitySafe; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36305);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _BricksProvider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29301);



var useObservabilitySafe = function() {
    var useObservability = (0,_BricksProvider__WEBPACK_IMPORTED_MODULE_1__/* .useAnalyticsContext */ .Os)().useObservability, trackJourneyEvent = useObservability().trackJourneyEvent;
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return {
            trackJourneyEvent: function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                try {
                    trackJourneyEvent.apply(void 0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(args));
                } catch (e) {}
            }
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
};



/***/ }),

/***/ 95998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Dimensions; }
/* harmony export */ });
/* harmony import */ var fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73759);
/* harmony import */ var fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _modules_canUseDom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13145);
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

'use client';



var dimensions = {
  window: {
    fontScale: 1,
    height: 0,
    scale: 1,
    width: 0
  },
  screen: {
    fontScale: 1,
    height: 0,
    scale: 1,
    width: 0
  }
};
var listeners = {};
var shouldInit = _modules_canUseDom__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z;
function update() {
  if (!_modules_canUseDom__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z) {
    return;
  }
  var win = window;
  var height;
  var width;

  /**
   * iOS does not update viewport dimensions on keyboard open/close.
   * window.visualViewport(https://developer.mozilla.org/en-US/docs/Web/API/VisualViewport)
   * is used instead of document.documentElement.clientHeight (which remains as a fallback)
   */
  if (win.visualViewport) {
    var visualViewport = win.visualViewport;
    /**
     * We are multiplying by scale because height and width from visual viewport
     * also react to pinch zoom, and become smaller when zoomed. But it is not desired
     * behaviour, since originally documentElement client height and width were used,
     * and they do not react to pinch zoom.
     */
    height = Math.round(visualViewport.height * visualViewport.scale);
    width = Math.round(visualViewport.width * visualViewport.scale);
  } else {
    var docEl = win.document.documentElement;
    height = docEl.clientHeight;
    width = docEl.clientWidth;
  }
  dimensions.window = {
    fontScale: 1,
    height,
    scale: win.devicePixelRatio || 1,
    width
  };
  dimensions.screen = {
    fontScale: 1,
    height: win.screen.height,
    scale: win.devicePixelRatio || 1,
    width: win.screen.width
  };
}
function handleResize() {
  update();
  if (Array.isArray(listeners['change'])) {
    listeners['change'].forEach(handler => handler(dimensions));
  }
}
class Dimensions {
  static get(dimension) {
    if (shouldInit) {
      shouldInit = false;
      update();
    }
    fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_0___default()(dimensions[dimension], "No dimension set for key " + dimension);
    return dimensions[dimension];
  }
  static set(initialDimensions) {
    if (initialDimensions) {
      if (_modules_canUseDom__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z) {
        fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_0___default()(false, 'Dimensions cannot be set in the browser');
      } else {
        if (initialDimensions.screen != null) {
          dimensions.screen = initialDimensions.screen;
        }
        if (initialDimensions.window != null) {
          dimensions.window = initialDimensions.window;
        }
      }
    }
  }
  static addEventListener(type, handler) {
    listeners[type] = listeners[type] || [];
    listeners[type].push(handler);
    return {
      remove: () => {
        this.removeEventListener(type, handler);
      }
    };
  }
  static removeEventListener(type, handler) {
    if (Array.isArray(listeners[type])) {
      listeners[type] = listeners[type].filter(_handler => _handler !== handler);
    }
  }
}
if (_modules_canUseDom__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z) {
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', handleResize, false);
  } else {
    window.addEventListener('resize', handleResize, false);
  }
}

/***/ }),

/***/ 13145:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
/* harmony default export */ __webpack_exports__["Z"] = (canUseDOM);

/***/ })

}]);